export default {
    name : 'DraftData',
    props : {
        data : {
            type: Object,
            required: true
        },
        isValidable : {
            type: Boolean,
            required: false,
            default: false
        },
        category: {
            type: String,
            required: false
        }
    }
};
